import { datadogLogs } from '@datadog/browser-logs';
var logError = function (message, params, exception) {
    if (message === void 0) { message = 'Error occurred'; }
    if (params === void 0) { params = {}; }
    if (exception === void 0) { exception = null; }
    datadogLogs.logger.error(message, params, exception);
    console.error(message, params, exception);
};
var logWarning = function (message, params, exception) {
    if (message === void 0) { message = 'Warning'; }
    if (params === void 0) { params = {}; }
    if (exception === void 0) { exception = null; }
    datadogLogs.logger.warn(message, params, exception);
    console.warn(message, params, exception);
};
var logInfo = function (message, params) {
    if (message === void 0) { message = 'Info'; }
    if (params === void 0) { params = {}; }
    datadogLogs.logger.info(message, params);
    console.log(message, params);
};
var logger = {
    logError: logError,
    logWarning: logWarning,
    logInfo: logInfo
};
export default logger;
